import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';

interface CreatePaymentIntentData {
  customerId: string;
  amount: number;
}

export async function createPaymentIntent(customerId: string | undefined, amount: number): Promise<AxiosResponse> {
  return backendApiInstance.post('stripe/create-payment-intent', { customerId, amount });
}

export async function getClientSecret(customerId: string | undefined): Promise<AxiosResponse> {
  return backendApiInstance.post('stripe/create-setup-intent', { customerId });
}

export async function retryPayment(amount: number): Promise<AxiosResponse> {
  return backendApiInstance.post('stripe/auto-capture', { amount });
}

export async function updatePaymentMethod(
  customerId: string | undefined,
  paymentMethodId: string | undefined,
): Promise<AxiosResponse> {
  return backendApiInstance.post('stripe/create-setup-intent', { customerId, paymentMethodId });
}

export async function createPortalSession(
  stripeAccountId: string | undefined,
  returnUrl: string,
): Promise<AxiosResponse> {
  return backendApiInstance.post('stripe/create-portal-session', {
    stripeAccountId,
    returnUrl,
  });
}

export const confirmPaymentAndUnlockApi = (paymentIntentId: string) =>
  backendApiInstance.post('/stripe/confirm-payment-and-unlock', { paymentIntentId });
